function sharedMessage(code: string | undefined): string | null {
  switch (code) {
    case 'auth/invalid-email':
      return 'Please enter a valid email address.';
    case 'auth/network-request-failed':
      return 'Network error. Please check your connection and try again.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait a moment and try again.';
    default:
      return null;
  }
}

export function getLoginErrorMessage(code: string | undefined): string {
  const shared = sharedMessage(code);
  if (shared) return shared;
  switch (code) {
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return 'Incorrect email or password. Please try again.';
    case 'auth/user-disabled':
      return 'This account has been disabled. Please contact support.';
    default:
      return 'Something went wrong signing in. Please try again.';
  }
}

export function getSignUpErrorMessage(code: string | undefined): string {
  const shared = sharedMessage(code);
  if (shared) return shared;
  switch (code) {
    case 'auth/email-already-in-use':
      return 'An account with this email already exists. Try signing in instead.';
    case 'auth/weak-password':
      return 'Please choose a stronger password.';
    default:
      return 'Something went wrong creating your account. Please try again.';
  }
}
